<template>
  <div class="a7-painel-tree">
    <gw-tree-table
    showFirstDepth
    child-nodes="filhos"
    :data="itens"
    :tree-column="1"
    :selected-node="selectedEntity"
    @selectedEntity="selectEntity">
      <gw-column :width="38">
        <div style="overflow-y: visible;" slot-scope="{row, expand}">
          <i class="fa fa-plus a7-expand-icon"
            v-if="!row.filhos"
            @click.stop.prevent
            @mousedown.prevent.stop="mostrarPopUp($event, expand)"></i>
          <i class="fa fa-minus a7-expand-icon"
            v-else-if="row.filhos"
            @click.stop="removerAgrupamento(row)"></i>
        </div>
      </gw-column>
      <gw-column title="Nível" field="nivel" :width="450">
        <template slot-scope="{value, row}">
          <i
            v-if="row.grupo == 'N'"
            @click.stop="emitShowInfo(row)"
            class="fa fa-info-circle fa-lg a7-info-icon"></i>
          <span class="a7-nivel-label">
            {{value}}
          </span>
        </template>
      </gw-column>
      <gw-column title="Desempenho (%)" field="desempenho">
        <template slot-scope="{value}">
          <gw-bar :completed-percentage="value" :color="legendColor(value)"/>
        </template>
      </gw-column>
      <gw-column title="Valor Médio" field="mediaValorMedicao">
        <template slot-scope="{row}">
          {{getValorMedia(row)}}
        </template>
      </gw-column>
      <gw-column title="Medições" field="contagemDesempenho" />
      <gw-column title="Avaliação" field="avaliacaoMedia" />
      <gw-column title="Nº Indicadores" field="contagemIndicador" />
      <gw-column title="Nº Un. Neg." field="contagemUnidadeNegocio" />
    </gw-tree-table>
    <gw-pop-up :visible.sync="showPopUp" reference-element-id="popupMenuReference"
      class="a7-pop-up-container">
      <div style="color: black; font-weight: normal;">
        <a7-pop-up-menu v-model="novoAgrupamento" :options="tiposAgrupamentosDisponiveis"/>
      </div>
    </gw-pop-up>
  </div>
</template>
<script>
import A7PopUpMenu from './A7PopUpMenu'
import {
  GwTreeTable,
  GwColumn,
  GwPopUp,
  Formatters,
  GwBar
} from 'guaxinim-web'

import {
  tiposAgrupamento,
  cores,
  agrupamentoDefaultDesktop,
  legendColor,
  formatarValorMedia
} from './A7PainelDefaultConfigurations'

export default {
  name: "a7-painel-tree",
  components: {
    GwTreeTable,
    GwColumn,
    GwPopUp,
    Formatters,
    GwBar,
    A7PopUpMenu
  },
  props: {
    itens: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    selectedEntity: null,
    showPopUp: false,
    // Gestão Nível 1 > Gestão Nível 2 > Depto. Nível 1 > Depto. Nível 2 > Indicador
    agrupamentosSelecionados: [...agrupamentoDefaultDesktop],
    novoAgrupamento: [],
    tiposAgrupamento,
    legendColor
  }),
  watch: {
    selectedEntity() {
      this.emitSelectedEntity()
    },
    novoAgrupamento(newValue) {
      this.showPopUp = false
      this.agrupamentosSelecionados = this.agrupamentosSelecionados.concat(newValue)
    },
    agrupamentosSelecionados: {
      immediate: true,
      handler(){
        if (this.expand) {
          this.expand(true)
          this.expand = null
        }
        this.showPopUp = false
        this.emitAgrupou(this.agrupamentosSelecionados)
      }
    },
    itens(newValue) {
      if (!newValue )
        return
      this.selectedEntity = newValue[0]
    },
  },
  computed: {
    selectedNode() {
      const vm = this
      return vm.itens && vm.itens[0] ? vm.itens[0] : null
    },
    tiposAgrupamentosDisponiveis() {
      return this.tiposAgrupamento
      .filter(item => !this.agrupamentosSelecionados.includes(item.value))
    },
  },
  methods: {
    selectEntity(entity) {
      this.selectedEntity = (entity) ? entity : this.itens[0]
    },
    setAgrupamento(agrupamento) {
      this.agrupamentosSelecionados = [...agrupamento]
      this.emitAgrupou(this.agrupamentosSelecionados)
    },
    emitSelectedEntity() {
      this.$emit('selected-entity', this.selectedEntity)
    },
    emitShowInfo(row) {
      this.$emit('show-info', row)
    },
    emitAgrupou(value) {
      this.$emit('agrupou', [...value])
    },
    mostrarPopUp(e, expand) {
      const vm = this
      vm.expand = expand
      Array.from(document.querySelectorAll('i#popupMenuReference'))
      .forEach(e => e.removeAttribute('id'))
      e.srcElement.setAttribute('id', 'popupMenuReference')
      vm.showPopUp = true
    },
    detalharDimensao(entidade) {
      this.showPopUp = !this.showPopUp
    },
    removerAgrupamento(entidade) {
      const index = this.agrupamentosSelecionados.indexOf(entidade.grupo)
      const novoAgrupamento = this.agrupamentosSelecionados.slice(0, index + 1)
      this.setAgrupamento(novoAgrupamento)
    },
    getValorMedia(row){
      return formatarValorMedia(row.mediaValorMedicao, row.medicaoUnidadeMedida)
    }
  }
}
</script>

<style lang="scss" scoped>
.a7-nivel-label {
    white-space: nowrap;
    text-overflow: ellipsis;
}

.a7-pop-up-container {
    width: auto !important;
}

.a7-info-icon {
    cursor: pointer;
    color: #0088ce;
    width: 12px;
    height: 12px;
    margin: 4px;
}

.a7-expand-icon {
    cursor: pointer;
    font-size: 12px;
    height: 20px;
    width: 20px;
    text-align: center;
    vertical-align: middle;
    margin-top: -2px;
    padding: 4px;
    color: #363636;
}</style>
